import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiFundingDocsIndex } from "../lib/api";

export default function ComplianceFundingDocuments() {
  const { funding } = useParams();
  const fundingId = Number(funding);
  const [loading, setLoading] = useState(true);
  const [payload, setPayload] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;

    apiFundingDocsIndex(fundingId)
      .then((res) => {
        if (!alive) return;
        setPayload(res);
        setError(null);
      })
      .catch((e: any) => {
        if (alive) setError(e?.message || "Could not load funding documents.");
      })
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [fundingId]);

  if (loading) return <div className="section-box skeleton">Loading...</div>;

  const docs = payload?.docs ?? [];
  const ref = payload?.funding?.reference ?? `#${fundingId}`;

  return (
    <div className="max-w-3xl mx-auto card-box space-y-6">
      <header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-xl font-semibold">Funding Documents</h1>
          <p className="text-sm text-gray-600">
            Funding reference: <span className="font-mono">{ref}</span>
          </p>
        </div>
        <div className="flex gap-2">
          <Link to={`/compliance/funding/${fundingId}/upload`} className="btn">
            Upload documents
          </Link>
          <Link to={`/funding/${fundingId}`} className="btn btn-white">
            Deposit instructions
          </Link>
        </div>
      </header>

      {error ? (
        <div className="alert-danger">{error}</div>
      ) : docs.length === 0 ? (
        <div className="alert-info">No compliance documents uploaded for this funding request.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="table-header">
              <tr>
                <th className="px-3 py-2 text-left">Type</th>
                <th className="px-3 py-2 text-left">Status</th>
                <th className="px-3 py-2 text-left">Uploaded</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {docs.map((doc: any) => (
                <tr key={doc.id}>
                  <td className="px-3 py-2 font-medium uppercase">{doc.type}</td>
                  <td className="px-3 py-2 capitalize">{doc.status}</td>
                  <td className="px-3 py-2 text-gray-600">
                    {doc.created_at ? new Date(doc.created_at).toLocaleString() : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
